export default function SimulationControls({ isPaused, onTogglePause }) {
  return (
    <div className="fixed bottom-[30px] right-[30px] flex items-center gap-3 z-[100]">
      <div className="bg-[#1a1a1a] border-2 border-[#444] px-4 py-2 rounded-[20px] text-[#888] text-[0.85rem] font-semibold tracking-[0.5px] uppercase">
        {isPaused ? 'Paused' : 'Running'}
      </div>
      <button
        onClick={onTogglePause}
        className={`w-[60px] h-[60px] rounded-full border-[3px] border-[#444] text-white text-2xl cursor-pointer transition-all shadow-[0_5px_15px_rgba(102,126,234,0.4)] flex items-center justify-center hover:scale-110 hover:shadow-[0_8px_20px_rgba(102,126,234,0.6)] active:scale-95 ${
          isPaused
            ? 'bg-gradient-to-br from-[#4caf50] to-[#81c784]'
            : 'bg-gradient-to-br from-[#667eea] to-[#764ba2]'
        }`}
        aria-label={isPaused ? 'Resume simulation' : 'Pause simulation'}
      >
        {isPaused ? '▶' : '⏸'}
      </button>
    </div>
  )
}

